<template>
<div>
    <Row >
    <Col>
    <Form ref="form" :model="forms" :rules="formRules">
          <FormItem
            v-for="(item, index) in sku_list"
            :key="index"
            :label="'场景' + index "
             v-model="value"
            >
           <Input type="text"  v-model="item.patrolScene" placeholder="请输入场景名称" style="width:150px"></Input>
            <Input  style="width:300px"  v-model="item.sceneSite" placeholder="请输入场景地址"></Input>
            <!-- <Input  style="width:150px"  v-model="item.market_sceneSite" placeholder="请输入市场价格"></Input>
            <Input  style="width:120px" @on-change='keywordNumChange' v-model="item.stock" placeholder="请输入库存"></Input> -->
            <span style="margin-left:15px;cursor: pointer;" v-if="index==0"    @click="handleAdd(index)">[ 增加 ]</span>
            <span style="margin-left:15px;cursor: pointer;" v-if="index!=0"   @click="handleRemove(index)">[ 删除 ]</span>
        </FormItem>

    </Form>
    </Col>
    </Row>
</div>
</template>
<script>
    export default {
        name: 'formInput',
        components: {
        },
        props: {
            value:Array
        },
        data () {
            return {
                index: 1,
                sku_list:[
                    {
                        patrolScene: '',
                        sceneSite:'',
                        // market_sceneSite:'',
                        // stock:'',
                    },
                ],
            }
        },
        created () {
            if(this.value){
             this.sku_list =  this.value 
            }
        },
        methods: {
            
            //关键词数量变化
            keywordNumChange(){
                let that = this
                 that.$emit('on-change', that.sku_list)
            },
            // 关键词 增加
            handleAdd () {
                let that = this
                that.sku_list.push({
                        patrolScene: '',
                        sceneSite: '',
                        // market_sceneSite:'',
                        // stock:'',
                    });
                      that.keywordNumChange()
            },
            // 关键词 删除
            handleRemove (index) {
                let that = this
               let data = that.sku_list
                data.splice(index,1)
                that.keywordNumChange()
            },
        }
    }
</script>
<style lang="less" scoped>
</style>

